import { currencies, DEFAULT_CURRENCY } from '@js/core/currencies.js';
import _ from 'lodash';

export function convert(amount, to, from) {
    if (!amount) {
        return 0;
    }

    if (_.isObject(amount)) {
        from = from || amount.currency;
        amount = amount.amount;
    } else {
        from = from || DEFAULT_CURRENCY;
    }

    const toRate = currencies[to]?.rate || 1;
    const fromRate = currencies[from]?.rate || 1;

    return _.round((amount / fromRate) * toRate, 2);
}

export function symbol(currency) {
    return currencies[currency]?.symbol || currency;
}
